import React from 'react';
import Loader from '../components/Loader';
import { messageUtility } from '../utilities/messageUtility';

// 現場配置印刷中メッセージを表示
export default class LayoutPrint extends React.Component {
  constructor(props) {
    super(props);

    // ローダーの枠が見切れるので
    Loader.disable();
  }

  render() {
    return (
      <div className='layout-print'>
        <div className='layout-print__body'>
          <div id={'printingMessage'}>
            <div className='indicator' />
            <div className='layout-print__message'>
              {this.props.message || messageUtility.getMessage('I-000-047')}
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/LayoutPrint.jsx